import { Localizations } from '@eig-builder/module-localization'

Localizations.append({
  modules: {
    crm: {
      components: {
        accountStatusChip: {
          cancelled: 'Cancelled',
          paid: 'Paid',
          free: 'Free'
        }
      }
    }
  }
})
